import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Contact from "../Contact/Contact.js";
import "./style.css";

import Chatt from "../works/img/chatt.jpg";



export default function DetailWork() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate()

  const handleClick = () => {
    navigate("/")
  }


  return (
    <>
      <nav onClick={handleClick} className='singleWork'>
        <p>Back</p>
      </nav>
      <div className="untree_co-section untree_co-section-4 pb-0" id="portfolio-section">
          <div className="container">
            <div className="portfolio-single-wrap unslate_co--section" id="portfolio-single-section">
              <div className="portfolio-single-inner">
                <h2 className="heading-portfolio-single-h2  mt-5" style={{color:"#063dcc"}}>SNAPPY CHAT</h2>

                <div className="row justify-content-between mb-5">
                  <div className="col-12 mb-4">
                    <div className="owl-carousel single-slider">
                    </div>
                  </div>
                  <div className="col-12 my-5">
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Project Date</h4>
                          <span className="detail-val" style={{color:"#063dcc"}}>Jan - Feb - 2023</span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Role</h4>
                          <span className="detail-val">
                            <span style={{color:"#063dcc"}}>User</span>
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Code</h4>
                          <a style={{color:"#063dcc"}} href="https://github.com/ASFER8384/snappy.git" className="detail-val"  target="_blank" >Live Github</a>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Website</h4>
                          <span className="detail-val">
                            <a style={{color:"#063dcc"}} href="https://snappy-chat-cbbv.onrender.com/"  target="_blank">Live Site</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    Explore our chat website, the ideal platform for connecting with people from all walks of life. Whether you're looking for casual conversation, insightful discussions, or sharing your interests, our user-friendly interface offers a seamless chat experience.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    Engage with diverse individuals, exchange ideas, and forge new connections. Our secure and welcoming environment allows you to have conversations on a wide range of topics. Join our dynamic chat community today and experience the joy of connecting with others in a meaningful and engaging way.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Contact />
    </>
  );
}
